import useApi from '../../../services/useApi'

const useGetCustomerGroupDropdown = () => {
  const Api = useApi()

  const {data: response, isLoading} = Api.useGetQuery(`/analytics/profitability/filters/customer-groups`)


  return {
    customerGroups: response?.data || [],
    isLoading: isLoading,
  }
}

export default useGetCustomerGroupDropdown
